import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'pxc-dropzone-content',
  imports: [TuiIcon],
  templateUrl: './dropzone-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex size-full min-h-0 flex-col items-center justify-center gap-1 overflow-hidden p-1 text-center text-xs leading-tight',
  },
})
export class DropzoneContentComponent {
  readonly label = input<string | null>(null);
  readonly draggedLabel = input<string | null>(null);
  readonly isDragged = input(false);
}
